<template>
  <div id="login">
    <div class="loginCard">
      <el-card shadow="always" class="login_left">
        <div class="login_title">
          <span class="CN">{{ $t("login.login_title") }} </span>
          <span class="EN">Construction Industry Association Work System</span>
        </div>

        <div class="login">
          <el-form :model="loginForm" ref="loginForm" status-icon :rules="rules">
            <el-form-item prop="username">
              <el-input type="text" v-model="loginForm.username" :placeholder="$t('login_input.userName')" clearable>
                <i slot="prefix" class="el-icon-user"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="loginForm.password" :placeholder="$t('login_input.password')"
                show-password>
                <i slot="prefix" class="el-icon-unlock"></i>
              </el-input>
            </el-form-item>
            <div class="forget" @click="forget">
              <span>{{ $t("login.forget") }}</span>
            </div>
            <el-form-item>
              <el-button class="subBtn" type="primary" @click="submitForm('loginForm')">{{ $t("login.login")
                }}</el-button>
            </el-form-item>
          </el-form>
        </div>

        <div class="login_foot">
          <el-col :span="24" style="margin-left: 50px">
            <el-col :span="12">{{ $t("login.login_foot1") }}</el-col>
            <!-- <el-col :span="5">{{ $t("login.login_foot2") }}</el-col> -->
            <el-col :span="7">{{ $t("login.login_foot3") }}</el-col>
          </el-col>
          <el-col :span="24" style="margin-left: 50px; margin-top: 5px">
            <el-col :span="12">{{ $t("login.login_foot4") }}</el-col>
            <el-col :span="12">{{ $t("login.login_foot5") }}</el-col>
          </el-col>
        </div>
      </el-card>

      <el-card class="login_right" shadow="never">
        <div class="title">
          <h1>DGCIA</h1>
        </div>
        <div class="text1">
          <p>欢迎注册成为会员</p>
        </div>
        <div class="text2">
          <p>加强管理，管理机构健全，保证管理人员到位，完善的会员体系管理。</p>
        </div>
        <div class="button">
          <el-button size="small" @click="toUserRegister">{{
            $t("register.memberRegister")
          }}</el-button>
        </div>
        <div class="button">
          <el-button size="small" @click="toExpertRegister">专家入库注册</el-button>
        </div>


        <div class="text3">
          <span @click="download('东莞市建筑业协会创优项目用户手册.zip')">{{
            $t("register.download")
          }}</span>
          <span @click="call">{{ $t("register.customerService") }}</span>
        </div>

        <p style="width: 35%; position: absolute; bottom: 0; right: 0">
          {{ $t("register.version") }}
        </p>
      </el-card>
    </div>
    <!-- <ModalSelect ref="registerSelect" /> -->
  </div>
</template>
<script>
import JSEncrypt from "jsencrypt";
import { addRouter } from "../router/index";
export default {
  inject: ["reload"],
  // components: { ModalSelect },
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          {
            required: true,
            message: this.$t("login_rules.userName"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("login_rules.password"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.enterSearch();
    this.$alert(`已注册会员账号是公司名字，密码是录入系统人设定密码<br>协会会员操作问题可联系陈先生076922658001转0或者13926862620`, '东莞市建筑业协会提示您：', {
      confirmButtonText: '确定',
      dangerouslyUseHTMLString: true,
      callback: action => {
        // this.$message({
        //   type: 'info',
        //   message: `action: ${action}`
        // });
      }
    })
  },
  methods: {
    enterSearch() {
      document.onkeydown = (e) => {
        //13表示回车键
        if (e.keyCode === 13) {
          this.submitForm("loginForm");
        }
      };
    },

    arrayToTree(arr, root) {
      return arr
        .filter((item) => item.parentId === root).sort((a, b) => {
          return a.displayOrder - b.displayOrder;
        })
        .map((item) => ({ ...item, children: this.arrayToTree(arr, item.id) }));
    },

    treeToArray(tree) {
      // tree是要传递的树形结构数组
      let arr = [];
      const expanded = (datas) => {
        if (datas && datas.length > 0) {
          datas.forEach((e) => {
            arr.push(e);
            expanded(e.children);
          });
        }
      };
      expanded(tree);
      return arr;
    },

    //登录
    async submitForm(formName) {
      await this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let storage = window.sessionStorage;
          let password = "";
          await this.$axios({
            url: "/backstage/api/getPublicKey",
            method: "get",
            params: {},
          }).then(async (res) => {
            password = this.encryptByPublicKey(
              res.data.data,
              this.loginForm.password
            );
            await this.$axios({
              url: "/backstage/login",
              method: "post",
              data: {
                pubKey: res.data.data,
                account: this.loginForm.username,
                password,
              },
            }).then(async (res) => {
              console.log(res.data);
              if (res.data.code == 200) {
                let result = res.data.data.token;
                let username = res.data.data.account;
                let userType = res.data.data.role.type;
                let userId = res.data.data.id
                await storage.setItem("token", result); // 保存用户登录信息
                await storage.setItem("userName", username); // 保存用户登录信息
                await storage.setItem("userType", userType); // 保存用户权限
                await storage.setItem("userId", userId); // 保存用户id
                const getMenus = JSON.parse(res.data.data.role.authority).map(
                  (item) => ({
                    ...item,
                    path: item.routeName,
                  })
                );
                console.log(getMenus);
                const menus = this.arrayToTree(getMenus, null).sort((a, b) => {
                  return a.displayOrder - b.displayOrder;
                });
                console.log(menus);
                // return null
                // this.$store.dispatch("setMenus", menus);
                storage.setItem("menus", JSON.stringify(menus));
                let nature = []
                await this.$axios({
                  url: "/backstage/membershipType/list",
                  method: "get",
                  params: {
                    pageNum: 0,
                    pageSize: 99,
                  },
                  headers: {
                    Authorization: "Bearer",
                  },
                })
                  .then((res) => {
                    if (res.data.code == 200) {
                      res.data.data.meta.forEach(element => {
                        nature.push({
                          value: element.id,
                          label: element.typeName
                        })
                      });
                    }
                    else {
                      console.log(res.data);
                      return;
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                    return
                  });
                storage.setItem("nature", JSON.stringify(nature));
                this.$message({
                  message: "登录成功",
                  type: "success",
                  duration: 2000,
                });
                this.$router.push({
                  path: "/index",
                });
                window.location.reload();
              } else {
                this.$message({
                  message: "登录失败," + res.data.message,
                  type: "error",
                  duration: 2000,
                });
              }
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    encryptByPublicKey(publicKey, content) {
      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(window.atob(publicKey)); // 设置公钥
      return encrypt.encrypt(content); // 加密内容
    },

    //忘记密码
    forget() {
      this.$router.push({
        path: "/forget",
      });
    },

    //下载
    download(fileName) {
      const fileUrl = "../../../../static/" + fileName; // 文件的URL地址
      this.$download(fileUrl, fileName);
    },

    //联系客服
    call() {
      this.$alert("客服服务电话：0769-22658001", "联系客服", {
        closeOnClickModal: true,
        showConfirmButton: false,
      });
    },
    //选择会员注册方式
    // selectRegisterType() {
    //   this.$refs.registerSelect.openDialog();
    // },
    //跳转到会员注册页面
    toUserRegister() {
      this.$router.push({
        path: "/register",
      });
    },

    //跳转到专家注册页面
    toExpertRegister() {
      this.$router.push({
        path: "/register?type=expert",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#login {
  width: 100%;
  height: 100%;
  background-color: #f1efef;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: url(../../../../static/img/login.png) no-repeat;
  background-size: 100% 100%;
  overflow-x: hidden;
}

/deep/ .el-message-box {
  width: 600px !important;
  // .el-message-box__title{
  //   font-size: 25px !important;
  // }
  // .el-message-box__content{
  //   font-size: 20px !important;
  // }
}

/deep/ .el-card {
  border: none !important;
}

.loginCard {
  width: 920px;
  height: 600px;
  display: flex;
  animation: slideIn 1s ease-in-out;

  @keyframes slideIn {
    from {
      transform: translateX(100%);
    }

    to {
      transform: translateX(0);
    }
  }

  .login_left {
    width: 71%;
    height: 100%;
    background-color: rgb(255, 255, 255);
    border-radius: 0;

    /deep/ .el-card__body {
      width: 100%;
      height: 100%;
      padding: 0;
    }

    .login_title {
      width: 100%;
      height: 23%;
      display: flex;
      flex-direction: column;
      justify-content: end;
      text-align: center;

      span {
        width: 100%;
      }

      .CN {
        font-size: 45px;
        font-weight: 500;
        color: #356fa9;
        font-family: "阿里妈妈东方大楷 Regular";
      }

      .EN {
        font-size: 16px;
        color: #356fa9;
      }
    }

    .login {
      width: 100%;
      height: 45%;
      margin-top: 7%;

      .el-form {
        width: 100%;
        height: 100%;

        /deep/ .el-form-item {
          height: 18%;
          margin-bottom: 20px;
        }

        /deep/ .el-form-item__content {
          height: 100%;
          display: flex;
          justify-content: center;
        }

        .el-input {
          height: 100%;
          width: 80%;
          font-size: 20px;
        }

        /deep/ .el-form-item__error {
          padding: 0;
          top: 85%;
          left: 10%;
        }

        .forget {
          width: 100%;

          span {
            margin-left: 80%;
            color: red;
          }

          span:hover {
            text-decoration: underline;
            cursor: pointer;
          }
        }

        .el-button {
          margin-top: 40px;
          width: 240px;
          height: 40px;
          font-size: 20px;
          line-height: 0;
        }
      }
    }

    .login_foot {
      width: 100%;
      margin-top: 10%;

      .el-col {
        display: flex;
        justify-content: flex-start;
      }
    }
  }

  .login_right {
    width: 29%;
    height: 100%;
    background-color: #356fa9;
    border-radius: 0;
    position: relative;

    /deep/ .el-card__body {
      padding: 0px;
    }

    .title {
      h1 {
        width: 100%;
        color: #002d5a69;
        font-size: 60px;
        letter-spacing: 10px;
        margin: 0;
        margin-left: 11px;
      }
    }

    .text1 {
      margin-top: 40px;

      p {
        font-size: 20px;
        color: #fff;
        text-align: center;
        line-height: 28px;
      }
    }

    .text2 {
      display: flex;
      justify-content: center;
      margin-bottom: 60px;

      p {
        width: 89%;
        color: #fff;
        text-align: center;
      }
    }

    .button {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 11px;

      .el-button {
        width: 70%;
        color: #356fa9;
        font-size: 14px;
      }
    }

    .text3 {
      width: 80%;
      display: flex;
      justify-content: space-between;
      margin-left: 10%;
      margin-top: 30px;
      color: #fff;

      span:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
}

.el-card.is-always-shadow {
  box-shadow: 0 0 15px 0 rgba(147, 196, 248, 0.192);
}
</style>



// WEBPACK FOOTER //
// src/system/index/login/index.vue